module.exports = __webpack_public_path__ + "img/img-25.4865f294.png";